"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeInstantRewardToJSON = exports.ChallengeInstantRewardFromJSONTyped = exports.ChallengeInstantRewardFromJSON = void 0;
var _1 = require("./");
function ChallengeInstantRewardFromJSON(json) {
    return ChallengeInstantRewardFromJSONTyped(json, false);
}
exports.ChallengeInstantRewardFromJSON = ChallengeInstantRewardFromJSON;
function ChallengeInstantRewardFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'questName': json['questName'],
        'questDescription': json['questDescription'],
        'isCompleted': json['isCompleted'],
        'isClaimed': json['isClaimed'],
        'target': json['target'],
        'progress': json['progress'],
        'games': (json['games'].map(_1.OWGameResponseFromJSON)),
    };
}
exports.ChallengeInstantRewardFromJSONTyped = ChallengeInstantRewardFromJSONTyped;
function ChallengeInstantRewardToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'questName': value.questName,
        'questDescription': value.questDescription,
        'isCompleted': value.isCompleted,
        'isClaimed': value.isClaimed,
        'target': value.target,
        'progress': value.progress,
        'games': (value.games.map(_1.OWGameResponseToJSON)),
    };
}
exports.ChallengeInstantRewardToJSON = ChallengeInstantRewardToJSON;
